import { ReactComponent as Pillar1 } from '../../images/pillar-1.svg';
import { ReactComponent as Pillar2 } from '../../images/pillar-2.svg';
import { ReactComponent as Pillar3 } from '../../images/pillar-3.svg';
import { ReactComponent as Pillar4 } from '../../images/pillar-4.svg';
import { ReactComponent as Pillar5 } from '../../images/pillar-5.svg';
import { ReactComponent as Pillar6 } from '../../images/pillar-6.svg';
import { ReactComponent as Pillar7 } from '../../images/pillar-7.svg';

export const PILLARS_ICONS = [Pillar1, Pillar2, Pillar3, Pillar4, Pillar5, Pillar6, Pillar7];

export const TABLES_WITH_MERGED_ROWS = [104, 107];

export const PRESERVE_BACKGROUND_AT_FIRST_COLUMN = [107];

export const TABLES_WITH_HIGHLIGHTED_CELL = [104, 105, 106, 107, 108, 132, 133, 134, 135];

export const TABLES_WITH_NO_HEADER = [132, 133, 134, 135];

export const TABLE_IDS = {
  PILLAR: 104,
  METHODOLOGY: 106,
  STAKEHOLDER_INVOLVEMENT: 108,
  SCORE: 109,
  CRISIS_BUDGETING_PILLAR: 658,
  SEYCHELLES_KEY_CRISIS: 656
};
